import { useExperiment } from '@/libraries/experiment';
import { MonetizationType } from '@/@types/graphql-types';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';

export function useJwtvCinematicPromotedOffers(title: MaybeRefOrGetter<TitleDetail>) {
	const { activeVariant: jwtvCinematicVariant } = useExperiment('EXP_JWTV_TVOD_CINEMATIC_V2');

	function applyJwtvCinematicOverride<
		T extends { package: { shortName: string }; monetizationType: MonetizationType }
	>(offers: T[]): T[] {
		if (jwtvCinematicVariant.value === null) return offers;

		const jwtvIndex = offers.findIndex(
			o => o.package.shortName === 'jwt' && o.monetizationType === MonetizationType.Rent
		);
		if (jwtvIndex === 0) return offers;
		if (jwtvIndex > 0) {
			return [offers[jwtvIndex], ...offers.filter((_, i) => i !== jwtvIndex)];
		}

		const titleValue = toValue(title);
		const jwtvRentOffer = titleValue.rent?.find(
			o => o.package.shortName === 'jwt' && o.monetizationType === MonetizationType.Rent
		);
		if (!jwtvRentOffer) return offers;

		return [jwtvRentOffer as unknown as T, ...offers.slice(1)];
	}

	return { applyJwtvCinematicOverride };
}
